import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../helpers/Helpers";
import { BASE_URL_MEDIA } from "../../../api/Constants";
import gymgirl from "../../../images/gymgirl.jpg";

const ProgramDetailsHeader = ({
  detail,
  viewType,
  setViewType,
  onDeleteProgram,
  onDuplicateProgram,
  onShowUsers,
  onViewProgramAttachment,
  navigate,
  id,
  isFilterVisible,
  onToggleFilter,
  onPlayVideo
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "Not set";
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getProgramStatus = () => {
    if (detail?.is_free) return "Free";
    if (detail?.is_public) return "Public";
    return "Paid";
  };

  const hasVideo = Boolean(detail?.video || detail?.youtube_link);

  return (
    <div className="program-details-header">
      <div className="program-main-info">
        <div className="program-image">
          <img 
            src={detail?.image ? getImageUrl(detail.image, BASE_URL_MEDIA) : gymgirl} 
            alt={detail?.name || "Program"}
            className="program-cover-image"
          />
          {hasVideo && (
            <button
              className="program-video-play"
              onClick={onPlayVideo}
              title="Play program video"
            >
              <i className="fa fa-play"></i>
            </button>
          )}
        </div>
        
        <div className="program-info">
          <div className="program-title-section">
            <h1 className="program-title">{detail?.name || "Program Name"}</h1>
            <div className="program-badges">
              <span className={`badge ${detail?.is_free ? 'badge-free' : detail?.is_public ? 'badge-public' : 'badge-paid'}`}>
                {getProgramStatus()}
              </span>
              {!detail?.is_free && detail?.price && (
                <span className="badge badge-price">${detail.price}</span>
              )}
            </div>
          </div>

          <div className="program-stats">
            <div className="stat-item">
              <i className="fa-solid fa-calendar-week"></i>
              <span>{detail?.number_of_weeks || 0} weeks</span>
            </div>
            <div className="stat-item">
              <i className="fa-solid fa-dumbbell"></i>
              <span>{detail?.workouts?.length || 0} workouts</span>
            </div>
            <div className="stat-item">
              <i className="fa-solid fa-users"></i>
              <span 
                className="clickable-stat"
                onClick={onShowUsers}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                title="Manage Members"
              >
                {detail?.users?.length || 0} members
              </span>
            </div>
            <div className="stat-item">
              <i className="fa-solid fa-calendar-days"></i>
              <span>Start: {formatDate(detail?.start_progress_date)}</span>
            </div>
          </div>

          {detail?.desc && (
            <div className="program-description">
              <p>{detail.desc}</p>
            </div>
          )}

          {detail?.youtube_link && (
            <div className="program-youtube">
              <a 
                href={detail.youtube_link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="youtube-link"
              >
                <i className="fa-brands fa-youtube"></i>
                Watch on YouTube
              </a>
            </div>
          )}
        </div>
      </div>

      <div className="program-actions">
        <div className="view-controls">
          <button
            className={`view-btn ${viewType === "list" ? "active" : ""}`}
            onClick={() => {
              setViewType("list");
              localStorage.setItem("viewType", "list");
            }}
          >
            <i className="fa-solid fa-list"></i>
            List view
          </button>
          <button
            className={`view-btn ${viewType === "calander" ? "active" : ""}`}
            onClick={() => {
              localStorage.removeItem("calenderViewDate");
              setViewType("calander");
              localStorage.setItem("viewType", "calander");
            }}
          >
            <i className="fa-solid fa-calendar"></i>
            Calendar view
          </button>
          <button
            className="view-btn create-workout-btn"
            onClick={() => navigate(`/create-workout/${id}`)}
          >
            <i className="fa-solid fa-plus"></i>
            Create workout
          </button>
          {viewType === "list" && (
          <button
            className={`view-btn filter-btn${isFilterVisible ? ' active' : ''}`}
            onClick={onToggleFilter}
            style={{ marginLeft: 8 }}
          >
            <i className="fa-solid fa-filter"></i>
            Workouts Filter
          </button>
          )}
        </div>

        <div className="action-controls">
          <button 
            className="action-btn users-btn"
            onClick={onShowUsers}
            title="Manage Users"
          >
            <i className="fa-solid fa-users-viewfinder"></i>
            <span>Members</span>
          </button>
          
          
            <button 
              className="action-btn attachments-btn"
              onClick={onViewProgramAttachment}
              title="View Attachments"
            >
              <i className="fa-solid fa-paperclip"></i>
              <span>{detail.attachments?.length} Files</span>
            </button>
          

          <Link to={`/edit-programm/${detail?.id}`} className="action-btn edit-btn">
            <i className="fa-regular fa-pen-to-square"></i>
            <span>Edit</span>
          </Link>

          <button 
            className="action-btn duplicate-btn"
            onClick={onDuplicateProgram}
            title="Duplicate Program"
          >
            <i className="fa-solid fa-copy"></i>
            <span>Duplicate</span>
          </button>

          <button 
            className="action-btn delete-btn"
            onClick={onDeleteProgram}
            title="Delete Program"
          >
            <i className="fa-solid fa-trash"></i>
            <span>Delete</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProgramDetailsHeader;
